import React from "react";
import "./styles/App.css";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Routes, Route } from "react-router-dom";
import routes, { RouteConfig } from "./config/routes";
import { Layout } from "pages/Layout";
import { PageLayout } from "components/authentication/PageLayout";
import useProfileData from "services/ProfileDataService";
import ProtectedRoute from "config/ProtectedRoute";

const MainContent = () => {
  const { isAdmin } = useProfileData();

  const renderRoutes = (routes: RouteConfig[]) => {
    return routes.map((route) => {
      const isProtected = route.path === "/users";

      const element = isProtected ? (
        <ProtectedRoute isAllowed={isAdmin}>
          <route.component />
        </ProtectedRoute>
      ) : (
        <route.component />
      );

      return (
        <React.Fragment key={route.path}>
          <Route path={route.path} element={element} />
          {route.children && renderRoutes(route.children)}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="App bg-[#F7F7F7]">
      <AuthenticatedTemplate>
        <Layout>
          <Routes>
            {renderRoutes(routes)}
          </Routes>
        </Layout>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <PageLayout />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default function App() {
  return <MainContent />;
}
